import { Component, inject, Input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ActionModal } from '../../../../shared/qplanning-commons/modals/action-modal.component';

@Component({
  selector: 'app-logout-confirmation-modal',
  standalone: true,
  imports: [ActionModal, TranslateModule],
  template: `
    <qpc-action-modal
      [heading]="'components.zenith.logout-confirmation-modal.title'"
      (onAction)="this.onAction.emit()"
      (onCancel)="this.onCancel.emit()">

      <p>{{ 'components.zenith.logout-confirmation-modal.message' | translate }}</p>
      <p>
        <a (click)="navigateToSynchronizationPage()" class="zn-link">
          {{ 'components.zenith.logout-confirmation-modal.navigateToSynchronizationPage' | translate }}
        </a>
      </p>

    </qpc-action-modal>
  `
})
export class LogoutConfirmationModalComponent {

  readonly onAction = output();
  readonly onCancel = output();

  private readonly router = inject(Router);

  navigateToSynchronizationPage() {
    this.router.navigate(['/', 'new', 'synchronization']);
    this.onCancel.emit();
  }
}
